import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import axiApi from "ApiCaller";
import {useTranslation} from "react-i18next";

const FormTabFleet = ({routes, setRoutes}) => {
    const {t: _Tr} = useTranslation("routes");
    const [trucks, setTrucks] = useState([]);
    const [drivers, setDrivers] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const respTrucks = await axiApi.get("/api/fleet/trucks/", {params: {size: 100}})
        if (respTrucks.data && respTrucks.data.items) setTrucks(respTrucks.data.items);

        const respDrivers = await axiApi.get("/api/fleet/drivers/")
        if (respDrivers.data && respDrivers.data.items) setDrivers(respDrivers.data.items);
    }

    const setRouteFleet = (index, key, value) => {
        setRoutes((current) =>
            current.map((route, idx) => {
                if (idx !== index) return route;
                return {...route, [key]: value};
            })
        );
    };

    const getIconRoute = (type) => {
        switch (type) {
            case "s":
                return <FontAwesomeIcon icon="location-dot" size="2xl" className="text-secondary"/>;
            case "d":
                return <FontAwesomeIcon icon="route" size="2xl" className="text-secondary"/>;
            case "f":
                return <FontAwesomeIcon icon="sack-xmark" size="2xl" className="text-secondary"/>;
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th style={{width: "42px"}}></th>
                            <th>{_Tr("labels.route")}</th>
                            <th className="text-center">{_Tr("labels.truck")}</th>
                            <th className="text-center">{_Tr("labels.driver")}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {routes.map((item, index) => (
                            <tr key={index}>
                                <td style={{verticalAlign: "middle"}} className="text-center">
                                    {getIconRoute(item.type)}
                                </td>
                                <td style={{verticalAlign: "middle"}}>{item.name}</td>
                                <td style={{verticalAlign: "middle"}}>
                                    <Form.Select
                                        size="sm"
                                        value={item.truck_id ?? ""}
                                        onChange={(e) =>
                                            setRouteFleet(
                                                index,
                                                "truck_id",
                                                e.target.value ? Number(e.target.value) : null
                                            )
                                        }>
                                        <option value="">— Sin camión —</option>
                                        {trucks.map((truck) => (
                                            <option key={truck.id} value={truck.id}>
                                                {truck.plate}
                                                {truck.identifier ? ` (${truck.identifier})` : ""}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </td>
                                <td style={{verticalAlign: "middle"}}>
                                    <Form.Select
                                        size="sm"
                                        value={item.driver_id ?? ""}
                                        onChange={(e) =>
                                            setRouteFleet(
                                                index,
                                                "driver_id",
                                                e.target.value ? Number(e.target.value) : null
                                            )
                                        }>
                                        <option value="">— Sin conductor —</option>
                                        {drivers.map((driver) => (
                                            <option key={driver.id} value={driver.id}>
                                                {driver.user__email}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default FormTabFleet;
